// Merlin api is not designed to get all breeds and colours at once
// So for them we need to get them whenever the parent selection changes
export function shouldGetBreedsAndColoursDynamically(pmsName: string){
  return pmsName === 'Merlin';
}
